import { render, staticRenderFns } from "./companyCreditInfo.vue?vue&type=template&id=23519eca&scoped=true"
import script from "./companyCreditInfo.vue?vue&type=script&lang=js"
export * from "./companyCreditInfo.vue?vue&type=script&lang=js"
import style0 from "./companyCreditInfo.vue?vue&type=style&index=0&id=23519eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23519eca",
  null
  
)

export default component.exports